// src/api/newsService.ts
import apiClient from './config';
import { NewsItem } from '../types/interfaces';

export const getNews = async (lang: string): Promise<NewsItem[]> => {
  const response = await apiClient.get(`/news?lang=${lang}`);
  return response.data;
};